<template>
  <div class="top-tip" :style="`top:${topNum}px;width:${width}px`">
    <span slot="icon">
      <div class="warn-icon">!</div>
    </span>
    <span style="padding-left: 14px">{{ content }}</span>
  </div>
</template>

<script>
export default {
  props:{
    width: {
      type: [String, Number],
      default: 1180,
    },
    top: {
      type: Number,
      default: 130,
    }
  },
  data() {
    return {
      topNum: 0,
    };
  },
  computed: {
    content() {
      const { orderPurchaseType } = this.$route.query;
      if(orderPurchaseType==9){
        return '温馨提示：如有问题，可向平台运营咨询，电话： 18322762493 / 15537902708';
      }else{
        return '温馨提示：注册开店前请先联系平台运营或客服人员咨询';
      }
    },
  },
  mounted() {
    this.topNum = this.top;
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 这里的 100 是阈值，你可以根据实际需要调整
      if (window.scrollY < this.top && window.scrollY>=0) {
        this.topNum = this.top - window.scrollY;
      } else {
        this.topNum = 0;
      }
    },
  },
};
</script>

<style>
.top-tip {

  background-color: #ffecde;
  font-size: 13px;
  height: 38px;
  border-radius: 2px;
  line-height: 38px;
  padding: 0px 30px;
  text-align: left;
  font-weight: 600;
  color: #ff7a45;
  position: fixed;
  box-sizing: border-box;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
.fixed-top {
  top: 0;
}
.warn-icon{
  border-radius: 50%;
    width: 18px;
    height: 18px;
    background-color: #ff7a45;
    display: inline-block;
    text-align: center;
    line-height: 18px;
    color: #fff;
    font-size: 14px;
    user-select: none;
}
</style>